import styled from 'styled-components';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { Input } from 'antd';
import { Box, Tab, styled as MuiStyled } from '@mui/material';

export const Wrapper = styled.div`
  background: #fff;
  padding: 50px;
  @media (max-width: 428px) {
    padding: 18px;
  }
`;
export const SearchIcon = styled(MagnifyingGlass)`
  position: absolute;
  top: 10px;
  right: 15px;
  color: #466afb;
  font-size: 20px;
`;
export const SearchWrapper = styled.div`
  position: relative;
`;
export const SSearchInput = styled(Input)`
  width: 100% !important;
  height: 40px !important;
  border: 1px solid #466afb;
  border-radius: 25px !important;
  padding-inline: 24px;
  padding-right: 40px;

  input {
    &::placeholder {
      color: #466afb;
      opacity: 0.75;
    }
    color: #466afb;
  }
`;
export const Title = styled.h4`
  font-size: 40px;
  color: #292d32;
`;
export const MenuWrapper = styled.div`
  background: #f9fbff;
  border-radius: 25px;
  max-width: 420px;
  margin-top: 32px;
`;

export const Content = styled.div`
  margin-top: 56px;
`;
export const ContentTitle = styled.h4`
  font-weight: 500;
  font-size: 20px;
  line-height: 135%;
  max-width: 524px;
  color: #292d32;
`;
export const Text = styled.p`
  margin-top: 16px;
  font-size: 16px;
  line-height: 135%;
  max-width: 756px;

  color: #292d32;

  opacity: 0.75;
`;
export const StyledButton = styled.button`
  font-size: 14px;

  color: #466afb;
`;
export const StyledBox = MuiStyled(Box)`
  display: flex;
  align-items: center;
  .MuiTabs-root {
    align-items: center;
  }
  .MuiTabs-indicator {
    display: none;
  }

  .Mui-selected {
    background: #466afb;
    border-radius: 17px;
    color: #ffffff !important;
  }
  .MuiTabs-flexContainer {
    overflow-x: hidden !important;
  }
`;
export const StyledTab = MuiStyled(Tab)`
  font-weight: 400;
  color: #466afb;
  min-height: 32px;
  font-size: 14px;
  text-transform: none;
  padding: 0;
  cursor: pointer;

  @media (max-width: 428px) {
    min-height: 32px;
    min-width: 26px;
  }
`;
